// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL
  || process.env.REACT_APP_API_BASE_URL
  || 'http://localhost:5000/api';

// Canvas reference width for scaling calculations
export const REFERENCE_WIDTH = 800;

// Background presets for vision boards
export const BACKGROUND_PRESETS = [
  { type: 'gradient', value: 'from-gray-50 to-gray-100', label: 'Light Gray' },
  { type: 'gradient', value: 'from-purple-50 to-pink-50', label: 'Purple Pink' },
  { type: 'gradient', value: 'from-blue-50 to-cyan-50', label: 'Blue Cyan' },
  { type: 'gradient', value: 'from-green-50 to-emerald-50', label: 'Green' },
  { type: 'gradient', value: 'from-yellow-50 to-orange-50', label: 'Warm' },
  { type: 'gradient', value: 'from-rose-50 to-pink-50', label: 'Rose' },
  { type: 'solid', value: 'bg-white', label: 'White' },
  { type: 'solid', value: 'bg-black', label: 'Black' },
  { type: 'pattern', value: 'dots', label: 'Dots' },
  { type: 'pattern', value: 'grid', label: 'Grid' },
];

// Common emojis for canvas elements
export const COMMON_EMOJIS = [
  '❤️', '⭐', '✨', '🌟', '💫', '🌈', '🦋', '🌸', '🌺', '🌻',
  '🌼', '🌷', '🏠', '🏖️', '✈️', '🎯', '💰', '💎', '👑', '🏆',
  '🎓', '📚', '💪', '🧘', '🏃', '🎨', '🎵', '☕', '🍷', '🎂'
];

// Frame styles for vision boards
export const FRAME_STYLES = [
  { name: 'Classic', border: '4px solid #8B4513', shadow: '0 4px 6px rgba(0,0,0,0.1)' },
  { name: 'Modern', border: '2px solid #333', shadow: '0 8px 16px rgba(0,0,0,0.15)' },
  { name: 'Gold', border: '6px solid #FFD700', shadow: '0 4px 12px rgba(255,215,0,0.3)' },
  { name: 'Silver', border: '5px solid #C0C0C0', shadow: '0 4px 10px rgba(192,192,192,0.3)' },
  { name: 'Vintage', border: '8px double #8B4513', shadow: '0 6px 12px rgba(0,0,0,0.2)' },
  { name: 'Polaroid', border: '16px solid #fff', shadow: '0 8px 20px rgba(0,0,0,0.25)', bottomBorder: '48px' },
];

// Canvas size presets
export const CANVAS_SIZES = [
  { name: 'A4', width: 210, height: 297, unit: 'mm', aspectRatio: 297/210 },
  { name: 'A4 Landscape', width: 297, height: 210, unit: 'mm', aspectRatio: 210/297 },
  { name: 'Letter', width: 8.5, height: 11, unit: 'in', aspectRatio: 11/8.5 },
  { name: 'Letter Landscape', width: 11, height: 8.5, unit: 'in', aspectRatio: 8.5/11 },
  { name: 'A3', width: 297, height: 420, unit: 'mm', aspectRatio: 420/297 },
  { name: 'A3 Landscape', width: 420, height: 297, unit: 'mm', aspectRatio: 297/420 },
  { name: 'Square', width: 210, height: 210, unit: 'mm', aspectRatio: 1 },
  { name: '16:9', width: 16, height: 9, unit: 'ratio', aspectRatio: 9/16 },
  { name: '4:3', width: 4, height: 3, unit: 'ratio', aspectRatio: 3/4 },
];

// Default canvas settings
export const DEFAULT_CANVAS_SIZE = { name: 'A4', width: 210, height: 297, unit: 'mm' };
export const DEFAULT_BACKGROUND = { type: 'gradient', value: 'from-gray-50 to-gray-100' };
